import { Grid, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { studentInsUpdSlice, selectStudentInsUpd } from "../../../redux/student/studentInsUpdSlice";
import { useAppDispatch } from "../../../app/hooks";
import AvatarUploadDragAndDrop from "../../../features/base/image/AvatarUploadDragAndDrop";

export function StudentInsUpdData2() {
    const studentInsUpd = useSelector(selectStudentInsUpd);
    const dispatch = useAppDispatch();

    const changed = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const student = {
            ...studentInsUpd.student
        };
        switch (event.target.id) {
            case "free-text":
                student.freeText = event.target.value;
                break;
            default:
                console.error("Invalid field id: " + event.target.id);
                return;
        }
        dispatch(studentInsUpdSlice.actions.set(student));
    };

    const handleAvatarChange = (img: string) => {
        const student = {
            ...studentInsUpd.student,
            url: img
        };
        dispatch(studentInsUpdSlice.actions.set(student));
    };
    
    return <>
        <Typography variant="h6" gutterBottom>
            {studentInsUpd.student.name}
        </Typography>
        <Grid container spacing={3}>
            <Grid size={12}>
                <TextField required id="free-text" name="free-text" label="Texto Livre"
                        fullWidth autoComplete="" variant="standard"
                        rows={6} multiline
                        value={studentInsUpd.student.freeText}
                        onChange={changed} />
            </Grid>
            <Grid size={12}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Avatar
                </Typography>
                <AvatarUploadDragAndDrop
                    value={studentInsUpd.student.url || ""}
                    onChange={handleAvatarChange}
                    alt={studentInsUpd.student.name}
                />
            </Grid>
        </Grid>
    </>;
}
